/* eslint-disable react/prop-types */
import React, {useEffect, useState} from 'react';

import {isEqual, isNaN} from 'lodash';
import {useDispatch, useSelector} from 'react-redux';

import * as modalActions from '@/actions/modalActions';
import * as setupActions from '@/actions/setupActions';
import {Delete, Post} from '@/api/request';
import CloseLockIcon from '@/assets/icons/lock-locked.svg';
import OpenLockIcon from '@/assets/icons/lock-unlocked.svg';
import OpenLockIconDisabled from '@/assets/icons/lock-unlockedDisabled.svg';
import * as APPDATA from '@/constants/pcConstAppData';
import {LockStatusPageEvent} from '@/constants/pubSubEnum';
import {eventBusObject} from '@/observers/eventBus';

function LockConcentrator({isRemoteView}) {
  const _bus = eventBusObject();
  const dispatch = useDispatch();
  const setupStore = useSelector((store) => store.setupStore, isEqual);
  const {isPCRunning, lockAccess} = setupStore;

  const [passwordValue, setPasswordValue] = useState(undefined);

  useEffect(() => {
    const eventLockUnlock = _bus.subscribe(LockStatusPageEvent.LOCK_UNLOCK_CONCENTRATOR, (param) =>
      lockUnlockStatusPage(param),
    );
    const eventButtonClick = _bus.subscribe(LockStatusPageEvent.ON_CLICK_LOCK_CONCENTRATOR, (param) =>
      updateTertiaryButtonProps(param),
    );

    return () => {
      eventLockUnlock.unsubscribe();
      eventButtonClick.unsubscribe();
    };
  }, []);

  useEffect(() => {
    const params = {
      isLockAccess: lockAccess,
    };
    updateTertiaryButtonProps(params);
  }, [isPCRunning, lockAccess]);

  const lockUnlockStatusPage = (param) => {
    let header;
    switch (param.state) {
      case State.LOCK:
        header = APPDATA.LOCK_ACCESS;
        break;
      case State.UNLOCK:
        header = APPDATA.UNLOCK_ACCESS;
        break;
      default:
        break;
    }
    showNumpadPassword(header);
  };

  const showNumpadPassword = (header) => {
    if (isRemoteView) {
      setPasswordValue('');
      const mobileLockUnlockButton = [
        {
          id: header,
          isPrimaryButton: true,
          onClick: onClickMobileLockUnlock,
          label: APPDATA.OK,
        },
      ];
      dispatch(
        modalActions.showPopUp({
          popUpTitle: header,
          popUpText: (
            <div className="center">
              <input
                className="inputPinRemote"
                // eslint-disable-next-line jsx-a11y/no-autofocus
                autoFocus
                id={header}
                type="tel"
                pattern="/d*"
                maxLength="4"
                onChange={onChangeMobilePassword}
                onKeyUp={keyUpMobilePassword}
              />
            </div>
          ),
          popUpQuestion: undefined,
          popUpButton: mobileLockUnlockButton,
        }),
      );
    } else {
      dispatch(
        modalActions.showModal({
          modalHeader: header,
          value: '',
          maxValue: '9999',
          minValue: '0',
          maxDigitAfterDecimal: 0,
          numpadMode: APPDATA.NUMPAD_MODE_PASSWORD,
          callback: submitPassword,
        }),
      );
    }
  };

  // ----------------------------- Mobile Method --------------------------------
  const keyUpMobilePassword = (e) => {
    if (e.keyCode === 13) {
      e.preventDefault();
      onClickMobileLockUnlock(e);
    }
  };

  const onClickMobileLockUnlock = (e) => {
    const buttonMode = {
      type: e.currentTarget.id,
      value: passwordValue,
    };
    submitPassword(buttonMode);
    dispatch(modalActions.hidePopUp());
  };

  const onChangeMobilePassword = (e) => {
    const newValue = e.currentTarget.value;
    console.log('newValue :', newValue);
    const keyPress = Number(newValue[newValue.length - 1]);

    // check, is last input number or character
    if (isNaN(keyPress)) {
      e.currentTarget.value = e.currentTarget.value.slice(0, -1);
      return false;
    }
    setPasswordValue(e.currentTarget.value);
    return true;
  };

  // ----------------------------- End Mobile method ----------------------------
  // ---------------------------- Submit Password to Backend Action -------------
  const submitPassword = (e) => {
    let param = {
      data: {
        Pin: e.value.toString(),
      },
    };
    switch (e.type) {
      case APPDATA.LOCK_ACCESS:
        param = {
          Pin: e.value.toString(),
        };
        Post(APPDATA.API.CONCENTRATOR_LOCK, param, successLock, {}, failedLock);
        break;
      case APPDATA.UNLOCK_ACCESS:
        param = {
          data: {
            Pin: e.value.toString(),
          },
        };
        Delete(APPDATA.API.CONCENTRATOR_LOCK, param, successUnlock, {}, failedUnlock);
        break;
      default:
        break;
    }
  };

  const successLock = () => {
    const params = {
      isLockAccess: true,
    };
    updateTertiaryButtonProps(params);
    dispatch(setupActions.updateLockAccess(true));
  };

  const failedLock = () => {};

  const successUnlock = () => {
    const params = {
      isLockAccess: false,
    };
    updateTertiaryButtonProps(params);
    dispatch(setupActions.updateLockAccess(false));
  };

  const failedUnlock = () => {
    dispatch(
      setupActions.showAlert({
        alertShow: true,
        alertText: APPDATA.MESSAGES.PIN.INVALID_PIN,
        alertStyle: APPDATA.ENUM.ALERT_TYPE.ALERT_DANGER,
      }),
    );
  };
  // ---------------------------- End Submit Password to Backend Action -------------

  // ---------------------------- Lock Button Action -----------------------------------------
  const updateTertiaryButtonProps = (param) => {
    const disableLockButton = param.isDisabled; // this.props.isPCRunning ? false : true
    const lockProps = {
      id: APPDATA.LOCK_ACCESS,
      className: 'unlockButton',
      icon: disableLockButton ? OpenLockIconDisabled : OpenLockIcon,
      disable: disableLockButton,
    };
    const unlockProps = {
      id: APPDATA.UNLOCK_ACCESS,
      className: 'lockButton',
      icon: CloseLockIcon,
      disable: disableLockButton,
    };

    const selectedProps = param.isLockAccess ? unlockProps : lockProps;
    const tertiaryButtonProps = {
      id: selectedProps.id,
      onClick: () => {
        _bus.publish(LockStatusPageEvent.LOCK_UNLOCK_CONCENTRATOR, {state: selectedProps.id});
      },
      className: selectedProps.className,
      icon: selectedProps.icon,
      disabled: selectedProps.disable,
    };
    if (isPCRunning) dispatch(setupActions.topButtonTertiaryProperties(tertiaryButtonProps));
  };
  // ---------------------------- End Lock Button Action -----------------------------------------

  return null;
}

export default LockConcentrator;

export const State = {
  LOCK: APPDATA.LOCK_ACCESS,
  UNLOCK: APPDATA.UNLOCK_ACCESS,
};
